
import DynamicTable from "@/components/DynamicTable";

import { type TableSchema } from "@/utils/tableUtils";
import { logHelper } from "@/utils";

const ChartTable = (props: any) => {

  const { tableData } = props;

  const tableSchemas = tableData
    .map((item: any) => ({
      type: 'table' as const,
      headers: (item as any).headers || [],
      data: (item as any).data || [],
      footer: (item as any).footer,
      title: (item as any).title,
      description: (item as any).description
    } as TableSchema));

  return (
    <div>
      {tableSchemas.map((schema: any, index: number) => (
        <DynamicTable
          key={`table-${index}`}
          schema={schema}
          size="small"
          bordered={true}
          pagination={false}
          summary={false}
          className="shadow-sm"
          chartName={tableData?.[0]?.title}
        />
      ))}
    </div>
  );
}


export default ChartTable;